import { forwardRef } from 'react'
import { Popover as PopoverPrimitive } from 'radix-ui'
import { cn } from '@/lib/utils'
import { SURFACE_MOTION_CLASS } from '@/components/ui/motion'

function Popover({ ...props }) {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />
}

const PopoverTrigger = forwardRef(({ className, ...props }, ref) => (
  <PopoverPrimitive.Trigger
    ref={ref}
    data-slot="popover-trigger"
    className={className}
    {...props}
  />
))
PopoverTrigger.displayName = PopoverPrimitive.Trigger.displayName

const PopoverContent = forwardRef(
  ({ className, align = 'center', sideOffset = 4, children, ...props }, ref) => (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        data-slot="popover-content"
        align={align}
        sideOffset={sideOffset}
        className={cn(
          SURFACE_MOTION_CLASS,
          'bg-popover text-popover-foreground z-[999] w-72 max-w-[calc(100vw-1rem)] max-h-[min(80vh,var(--radix-popover-content-available-height))] rounded-md border border-border/20 p-4 shadow-md outline-hidden origin-(--radix-popover-content-transform-origin) overflow-x-hidden overflow-y-auto overscroll-contain',
          className,
        )}
        {...props}
      >
        {children}
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>
  ),
)
PopoverContent.displayName = PopoverPrimitive.Content.displayName

const PopoverAnchor = forwardRef((props, ref) => (
  <PopoverPrimitive.Anchor ref={ref} data-slot="popover-anchor" {...props} />
))
PopoverAnchor.displayName = PopoverPrimitive.Anchor.displayName

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor }
